import { isString, isNumber } from 'lodash-es'
import { coerceNumberOrTrimmedString } from '@/utils/formatters'

const KEY_SEPARATOR = '::'

const splitFieldKey = (fieldKey) => {
  if (!fieldKey || typeof fieldKey !== 'string') return []
  return fieldKey.split(KEY_SEPARATOR)
}

const removeFieldKeyPrefix = (key, modelId) => {
  const prefix = `${modelId}${KEY_SEPARATOR}`
  return key.startsWith(prefix) ? key.replace(prefix, '') : key
}

const parsePrimaryKeyAndSource = (fieldKey, keyPrefix) => {
  const fieldKeyParts = splitFieldKey(removeFieldKeyPrefix(fieldKey, keyPrefix))

  const sourceType = fieldKeyParts.pop()

  return {
    primaryKey: fieldKeyParts.length > 0 ? fieldKeyParts.join(KEY_SEPARATOR) : null,
    sourceType: sourceType ?? null,
  }
}

const shouldHideField = ({ fieldKey, tableSettings, visibleColumnIds }) => {
  if (!fieldKey || typeof fieldKey !== 'string') return false

  if (visibleColumnIds && !visibleColumnIds?.includes(fieldKey)) return true

  const isExperimental = fieldKey.toLowerCase().includes('experimental')
  const isPredicted = !fieldKey.toLowerCase().includes('experimental')

  if ((isExperimental && !tableSettings.showExperimental) || (isPredicted && !tableSettings.showPredicted)) {
    return true
  }

  return false
}

const compareNormalizedValues = (aValue, bValue) => {
  if (typeof aValue === 'number' && typeof bValue === 'number') return aValue - bValue
  if (typeof aValue === 'number') return -1
  if (typeof bValue === 'number') return 1
  return aValue.localeCompare(bValue)
}

const compareValuesNullsLast = (aValue, bValue, isDescending) => {
  const validatedAValue = coerceNumberOrTrimmedString(aValue)
  const validatedBValue = coerceNumberOrTrimmedString(bValue)
  if (validatedAValue === null && validatedBValue === null) return 0
  if (validatedAValue === null) return isDescending ? -1 : 1
  if (validatedBValue === null) return isDescending ? 1 : -1
  return compareNormalizedValues(validatedAValue, validatedBValue)
}

const getChemicalMassFromParams = (params) => params?.data?.chemical?.averageMass

export { KEY_SEPARATOR, shouldHideField, parsePrimaryKeyAndSource, compareValuesNullsLast, getChemicalMassFromParams }
